var API_DOMAIN = "https://amarancrackers.com/api";

export default API_DOMAIN;
